import {hasValue} from 'web-app/util/typescript';

import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type ChildSummaryResponse} from './child-summary-data';

export function childSummaryTypePatcher(data: ChildSummaryResponse): RestTypeWithTypename<ChildSummaryResponse> {
    if (!hasValue(data)) {
        return data;
    }

    return {
        __typename: 'ChildSummaryData',
        institution: {
            __typename: 'Institution',
            ...data.institution,
        },
        child: {
            __typename: 'Child',
            ...data.child,
        },
        tags: data.tags.map(tag => ({__typename: 'Tags', ...tag})),
        relations: data.relations.map(relation => ({__typename: 'Relations', ...relation})),
    };
}
